"use client";
import * as React from "react";
import { useState } from "react";
import CreateOIDCConnection from "./oidc/index";
import CreateSAMLConnection from "./saml/index";
import type { CreateConnectionProps, CreateSSOConnectionProps } from "../types";
import RadioGroup from "../../../shared/RadioGroup/index";
import Radio from "../../../shared/Radio/index";
import Spacer from "../../../shared/Spacer/index";

function CreateSSOConnection(props: CreateSSOConnectionProps) {
  const [newConnectionType, setNewConnectionType] = useState(() => "saml");

  function connectionIsSAML() {
    return newConnectionType === "saml";
  }

  function connectionIsOIDC() {
    return newConnectionType === "oidc";
  }

  function sanitizedDefaults() {
    return {
      ...props.defaults,
      tenant: props.defaults?.tenants || props.defaults?.tenant,
    };
  }

  function handleNewConnectionTypeChange(event: Event) {
    setNewConnectionType((event.target as HTMLInputElement).value);
  }

  return (
    <div>
      <RadioGroup label="Select SSO type:">
        <Radio
          name="connection"
          value="saml"
          checked={newConnectionType === "saml"}
          handleInputChange={handleNewConnectionTypeChange}
        >
          SAML
        </Radio>
        <Radio
          name="connection"
          value="oidc"
          checked={newConnectionType === "oidc"}
          handleInputChange={handleNewConnectionTypeChange}
        >
          OIDC
        </Radio>
      </RadioGroup>
      <Spacer y={4} />
      {connectionIsSAML() ? (
        <CreateSAMLConnection
          urls={props.urls}
          excludeFields={props.excludeFields?.saml}
          readOnlyFields={props.readOnlyFields?.saml}
          classNames={props.classNames}
          variant={props.variant?.saml}
          errorCallback={props.errorCallback}
          successCallback={props.successCallback}
          cancelCallback={props.cancelCallback}
          displayHeader={false}
          defaults={sanitizedDefaults()}
        />
      ) : null}
      {connectionIsOIDC() ? (
        <CreateOIDCConnection
          urls={props.urls}
          excludeFields={props.excludeFields?.oidc}
          readOnlyFields={props.readOnlyFields?.oidc}
          classNames={props.classNames}
          variant={props.variant?.oidc}
          errorCallback={props.errorCallback}
          successCallback={props.successCallback}
          cancelCallback={props.cancelCallback}
          displayHeader={false}
          defaults={sanitizedDefaults()}
        />
      ) : null}
    </div>
  );
}

export default CreateSSOConnection;
